import React from 'react';
import {
  getMatchDomain,
  getMatchPageUrl,
  getMatchThumbnailUrl,
} from '../utils/safetyResults';
import ArtImageFallback from './ArtImageFallback';

/**
 * One reverse-image hit (TinEye-shaped from API) or Serper term hit.
 */
const SafetyResultCard = ({ item }) => {
  const info = typeof item === 'string' ? JSON.parse(item) : item;

  const pageUrl = getMatchPageUrl(info);
  const thumbUrl = getMatchThumbnailUrl(info);
  const domain = getMatchDomain(info);
  const width = info.width || info.thumbnailWidth || '—';
  const height = info.height || info.thumbnailHeight || '—';
  const provider = info.source_provider ? ` · ${info.source_provider}` : '';

  return (
    <div className="bg-white p-4 md:flex gap-4">
      <ArtImageFallback
        src={thumbUrl}
        alt=""
        className="object-cover max-w-full max-h-full"
        wrapperStyle={{ width: 150, height: 100, flexShrink: 0 }}
      />
      <div className="mt-2 md:mt-0 min-w-0">
        {domain && (
          <a
            href={pageUrl || `https://${domain}`}
            target="_blank"
            rel="noreferrer"
            className="block text-xl mb-2 break-all"
          >
            {domain}
          </a>
        )}
        {pageUrl && (
          <a
            href={pageUrl}
            target="_blank"
            rel="noreferrer"
            className="text-red-600 text-sm break-all block"
          >
            {pageUrl}
          </a>
        )}
        <p className="text-blue-600 mt-3 text-sm">
          RESOLUTION: {width} × {height}
          {provider}
        </p>
      </div>
    </div>
  );
};

export default SafetyResultCard;
